import { useMemo } from 'react';
import type { FixedOptionInputBaseProps } from '../fixed-option-select-input/shared';

const ENUM_PREFIX = 'enum';

export interface BaseEnumOptionInputProps<TEnum extends Record<string, TValue>, TValue extends string = string> {
  enumName: string;
  enumValue: TEnum;
}

export function useEnumFixedOptionInputProps<TEnum extends Record<string, TValue>, TValue extends string = string>({
  enumName,
  enumValue,
}: BaseEnumOptionInputProps<TEnum, TValue>): Pick<FixedOptionInputBaseProps<TValue>, 'i18nPrefix' | 'i18nValueName' | 'optionValues'> {
  const enumValues = useMemo(() => Object.values(enumValue).filter((v) => v !== 'UNSPECIFIED') as TValue[], [enumValue]);

  return useMemo(
    () => ({
      i18nPrefix: ENUM_PREFIX,
      i18nValueName: enumName,
      optionValues: enumValues,
    }),
    [enumValues, enumName],
  );
}
